<script lang="ts">
	// src/routes/(app)/(platform)/(videos)/videos/+page.svelte
	import FullVideoList from '$lib/components/platform/pages/videos/VideoList.svelte';
	import Meta from '$lib/components/Meta.svelte';
	import { page } from '$app/stores';
	import SearchFilter from '$lib/components/platform/SearchFilter.svelte';
	import Button from '$lib/components/ui/Button_2.0.svelte';
	import VideoFilterBtnList from '$lib/components/platform/VideoFilterBtnList.svelte';

	export let data;

	$: search = $page.url.searchParams.get('search') && $page.url.searchParams.get('search') !== '';
</script>

<Meta
	title={data.page.title}
	description={data.page.description}
	image={data.page.public_image_url}
/>

<div class="space-y-2">
	<VideoFilterBtnList sectors={data.sectors} class="mb-16" />
	<h1 class="text-3xl">
		{#if search}
			Search results
		{:else}
			What do you want to learn?
		{/if}
	</h1>
	<div class="flex items-center justify-between">
		<div class="flex w-full flex-col items-center justify-between gap-4 sm:flex-row">
			<div class="w-full grow lg:w-auto">
				<SearchFilter placeholder="Search" value={$page.url.searchParams.get('search') || ''} />
			</div>
		</div>
	</div>
</div>

<main class="mt-8">
	<div class="bg-white">
		<FullVideoList />
	</div>
</main>
